export default __webpack_public_path__ + "static/media/regional-map-page-desktop-min.48407938.jpeg";